import { EmploymentType, OrganisationType } from "api/resources/profile/types"

export const defaultOrganizationOptions = [
  { label: "School", value: OrganisationType.SCHOOL },
  {
    label: "College/University",
    value: OrganisationType.COLLEGE_OR_UNIVERSITY,
  },
  {
    label: "Tutoring",
    value: OrganisationType.TUTORING,
  },
]

export const employmentTypeOptions = [
  { label: "Full Time", value: EmploymentType.FULL_TIME },
  { label: "Part time", value: EmploymentType.PART_TIME },
  { label: "Fresher", value: EmploymentType.FRESHER },
  { label: "Intern", value: EmploymentType.INTERN },
  { label: "Freelancer", value: EmploymentType.FREELANCE },
  { label: "Self-Employed", value: EmploymentType.SELF_EMPLOYED },
]
